module.exports = __webpack_public_path__ + "img/price_comparison_2.8df99d23.png";